import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport, } from '@/components/ui/toast';
import { useToast } from '@/hooks/use-toast';
export function Toaster() {
    const { toasts } = useToast();
    return (_jsxs(ToastProvider, { children: [toasts.map(function ({ id, title, description, action, duration, variant, ...props }) {
                // Errors used to sit for ten seconds. That reads as a modal the reader
                // has to wait out: it covers the bottom-right corner of the viewport
                // through the next several actions, and a radiologist working a study
                // has usually understood and moved on long before it clears. Five
                // seconds is long enough to read two sentences and short enough to
                // stay out of the way. A caller that genuinely needs longer can still
                // pass an explicit `duration`.
                const dismissMs = duration ?? (variant === 'destructive' ? 5_000 : 4500);
                return (_jsxs(Toast, { variant: variant, duration: dismissMs, ...props, children: [_jsxs("div", { className: "grid gap-1", children: [title && _jsx(ToastTitle, { children: title }), description && _jsx(ToastDescription, { children: description })] }), action, _jsx(ToastClose, {})] }, id));
            }), _jsx(ToastViewport, {})] }));
}
